import React from 'react';
import { formatChatDateTime, formatChatTime } from './chatTime';

export const SourceTime = ({ receipt }) => {
  if (!receipt.source_timestamp) return null;
  return <span data-testid={`receipt-source-time-${receipt.id}`} title={`Mensaje original (hora argentina): ${formatChatDateTime(receipt.source_timestamp)}`} className="block text-[10px] text-gray-500 dark:text-gray-400">Chat {formatChatTime(receipt.source_timestamp)}</span>;
};